export const CURRENT_CONFIG = {

  // license
  appId: '164268',
  appKey: '1aeb3793f5f544b991d42a025624e18',
  appLicense: 'VGcvdXlmBMLAtZHp2AhqGjNiTdC7t6l46ZqzPD8f6TLNEcJBFc2qiZyZnUnb7lMvNzjuP8HQZQde5IX7CF8zekBhy4lFpm+Mu+rEagdurDlqzEm4R12iqRhB0K5FlLiD7soVzHWw1dJBrdlNiOKbFBwwg52OJXds3YrRcifysF4=',

  // http
  baseURL: 'https://djicloud.oceanpact.app/cloudapi/', // This url must end with "/". Example: 'http://192.168.1.1:6789/'
  websocketURL: 'wss://djicloud.oceanpact.app/cloudapi/api/v1/ws', // Example: 'ws://192.168.1.1:6789/api/v1/ws'

  // livestreaming
  // RTMP  Note: This IP is the address of the streaming server. If you want to see livestream on web page, you need to convert the RTMP stream to WebRTC stream.
  // O Servidor do Digital OCP espera o formato 'rtmp://live.oceanpact.com:1935/djicloud/{SN}'
  rtmpURL: 'rtmp://live.oceanpact.com:1935/djicloud/', // Example: 'rtmp://192.168.1.1/live/'

  // GB28181 Note:If you don't know what these parameters mean, you can go to Pilot2 and select the GB28181 page in the cloud platform. Where the parameters same as these parameters.
  gbServerIp: 'Please enter the server ip.',
  gbServerPort: 'Please enter the server port.',
  gbServerId: 'Please enter the server id.',
  gbAgentId: 'Please enter the agent id',
  gbPassword: 'Please enter the agent password',
  gbAgentPort: 'Please enter the local port.',
  gbAgentChannel: 'Please enter the channel.',
  // RTSP
  rtspUserName: 'Please enter the username.',
  rtspPassword: 'Please enter the password.',
  rtspPort: '8554',
  // Agora
  agoraAPPID: 'Please enter the agora app id.',
  agoraToken: 'Please enter the agora temporary token.',
  agoraChannel: 'Please enter the agora channel.',

  // map
  // You can apply on the AMap website.
  amapKey: 'Please enter the amap key.',

}
